import * as React from "react";
import {SquareProps} from "./SquareState";

export default function Square (props: SquareProps) {
    return (
      <button className="square" onClick={() => props.onClick()}>
        {props.value}
      </button>
    );
}